import { lazy, Suspense } from "react";
import Page from "@jumbo/shared/Page";
import orderMiddleware from "./middleware/auth/orderValidRoute";

// ✅ Lazy imports
const ListOrder = lazy(() => import("app/pages/VeneerOrder/Orders/List"));
const CreateGroupOrder = lazy(() => import("app/pages/VeneerOrder/Orders/Create/createGroup"));
const CreateRawOrder = lazy(() => import("app/pages/VeneerOrder/Orders/Create/createIndividual"));
const EditRawOrder = lazy(() => import("app/pages/VeneerOrder/Orders/Edit/editIndividual"));
const EditGroupOrder = lazy(() => import("app/pages/VeneerOrder/Orders/Edit/editGroup"));

export const orderRoutes = [
  {
    middleware: [
      {
        element: orderMiddleware,
        fallbackPath: "/dashboard",
      },
    ],
    routes: [
      {
        path: "/dashboard/orders",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={ListOrder} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/dashboard/orders/create-group-order",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={CreateGroupOrder} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/dashboard/orders/create-raw-order",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={CreateRawOrder} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/dashboard/orders/edit-raw-order",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={EditRawOrder} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      {
        path: "/dashboard/orders/edit-group-order",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Page component={EditGroupOrder} layout={"vertical-default"} />
          </Suspense>
        ),
      },
      // {
      //   path: "/dashboard/orders/edit",
      //   element: (
      //     <Suspense fallback={<div>Loading...</div>}>
      //       <Page component={AddOtherGoods} layout={"vertical-default"} />
      //     </Suspense>
      //   ),
      // },
    ],
  },
];
